import { getCurrentUser } from '../../../../utils/RoleManager';
import { USER_ROLES } from '../../../../constants/userRoles';

/** Motivo mostrado no botão travado (mesma regra de public/api/patients/ClinicalRecordAuthor.php). */
export const RECORD_LOCK_REASON = 'Só quem escreveu este registro, o proprietário ou o administrador da conta pode alterá-lo.';

/**
 * A equipe anula ou edita só o que escreveu; proprietário e administrador
 * corrigem qualquer registro. Registro antigo sem autor: só os dois.
 * @param {number|string|null} createdBy - Autor gravado no registro
 * @returns {boolean}
 */
export const canChangeRecord = (createdBy) => {
  const user = getCurrentUser();
  if ([USER_ROLES.COMPANY_OWNER, USER_ROLES.COMPANY_ADMIN].includes(user?.role)) return true;
  const author = parseInt(createdBy, 10);
  return author > 0 && user?.id != null && author === parseInt(user.id, 10);
};
